import { makeContextModule } from '@cian/react-utils';

import { type TGetOffersByPinResponse_1 } from '@/repositories/generated/shared/search-offers/v1/get-offers-by-pin';

export const {
  Context: { Provider: ListingByPinContextProvider },
  useContext: useListingByPinContext,
} = makeContextModule<TGetOffersByPinResponse_1>({
  contextName: 'ListingByPinContext',
});
